import React, { Component } from 'react';
import {observer} from "mobx-react"
import SortieStore from "../SortieStore"
import axios from "axios"
import { HashRouter as Router, Route, Link } from "react-router-dom";

@observer
class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };
    SortieStore.loadPieces()
  }
  componentDidMount(){
  }
  render() {
    if(SortieStore.loaded){

      return(
        <div>
            <h1 className="center">Etat des lieux de sortie</h1>
            <div className="row">
              {SortieStore.pieces.map((piece)=>(
                  <Link key={piece.id} to={"/expertise/piece/"+piece.id+"/"+piece.typedepiece.titre}>
                  <div  style={blocks} className="orange">
                    <h2 className="center white-text">{piece.typedepiece.titre}</h2>
                    <p className="center white-text">pièce numéro {piece.numero || "Non défini"}</p>
                  </div>
                  </Link>
                ))}
            </div>
        </div>
        )
    }else{
     return (
        <div>
        Chargement en cours
        </div>
      );
   }
  }
}
const blocks = {
  display: "inline-block",
  width: "21vw",
  marginLeft: "1.5vw",
  marginRight: "1.5vw",
  marginBottom: "1.5vw"

}



export default Dashboard
